/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface IseeCittadinoDTO { 
    id?: string;
    anno_di_riferimento?: number;
    valore?: number;
    version?: number;
    created_at?: string;
    updated_at?: string;
}

